import Reflux from 'reflux';
import TeamData from 'shared/data/Team';

let async = { asyncResult: true },
  LabelFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    create: async,
    populate: {},
    clear: {},
  });

LabelFormActions.create.listenAndPromise(TeamData.createLabel);

export default LabelFormActions;
